export default __webpack_public_path__ + "static/media/jatin-1.cd502a54.png";